'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tone = require('tone');

var _tone2 = _interopRequireDefault(_tone);

var _util = require('./util');

var _signalWindows = require('signal-windows');

var _fft = require('fft.js');

var _fft2 = _interopRequireDefault(_fft);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fft_size = 512;
var fft_overlap = fft_size / 4;

var fft = new _fft2.default(fft_size);

function toSpectrum(pcm, sr) {
  sr = sr || 44100;
  var ham = _signalWindows.windows.construct('ham', fft_size);
  var pcm_in = new Array(fft_size);
  var pcm_length = pcm.length;
  var pcm_q_length = Math.ceil(pcm_length / fft_size) * fft_size;
  var i = void 0,
      j = void 0,
      fft_out = void 0,
      data = [];
  for (i = -fft_size; i < pcm_q_length; i += fft_overlap) {
    for (j = 0; j < fft_size; j++) {
      pcm_in[j] = pcm[i + j] * ham[j] || 0;
    }
    fft_out = fft.createComplexArray();
    fft.realTransform(fft_out, pcm_in);
    fft.completeSpectrum(fft_out);
    data.push(fft_out);
  }
  return {
    data: data,
    sr: sr,
    fft_size: fft_size,
    fft_overlap: fft_overlap
  };
}

function fromSpectrum(spec) {
  var data = spec.data;
  var sr = spec.sr;
  var fft_size = spec.fft_size;
  var fft_overlap = spec.fft_overlap;
  var spec_len = data.length;

  var ham = _signalWindows.windows.construct('ham', fft_size);
  var out = fft.createComplexArray();
  var pcm_length = fft_overlap * spec_len;

  var audioBuffer = _tone2.default.context.createBuffer(1, pcm_length, sr);
  var pcm = audioBuffer.getChannelData(0);

  var i = void 0,
      j = void 0,
      u = void 0,
      col = void 0;

  for (i = 0; i < spec_len; i++) {
    col = data[i];
    // for (j = fft_size; j < fft_size << 1; j++) {
    //   col[j] = 0
    // }
    // if (i == 0) console.log(col)
    fft.inverseTransform(out, col);
    u = i * fft_overlap;
    for (j = 0; j < fft_size; j++) {
      pcm[u + j] += out[j * 2] * ham[j] || 0;
    }
  }

  fadeInOut(pcm, fft_size);
  // console.log(pcm)
  return audioBuffer;
}

function fromImageData(imageData, sr, _r, _i) {
  var pixels = imageData.data;
  var w = imageData.width;
  var h = imageData.height;
  var data = new Array(w);
  var x = void 0,
      y = void 0,
      u = void 0,
      v = void 0,
      v2 = void 0;
  for (y = 0; y < h; y++) {
    var col = data[y] = new Float32Array(h * 4);
    for (x = 0; x < w; x++) {
      u = (x * w + y) * 4;
      v = x * 2;
      col[v] = (pixels[u] / 255 - 0.5) * _r;
      col[v + 1] = (pixels[u + 1] / 255 - 0.5) * _i;
      v2 = (h - y + h) * 2;
      col[v2] = col[v];
      col[v2 + 1] = 0; // col[v+1]
    }
    col[h * 2] = col[h * 2 + 1] = col[h * 2 - 1] = col[h * 2 - 2] = 0;
  }
  var spec = {
    data: data,
    sr: sr,
    fft_size: fft_size, fft_overlap: fft_overlap
  };
  return spec;
}

function binToHz(spec, i) {
  return i / spec.fft_size * spec.sr;
}

function fadeInOut(pcm, fade_size) {
  var pcm_length = pcm.length;
  var fade = 0,
      i = void 0;
  for (i = 0; i < fade_size; i++) {
    fade = i / fade_size;
    fade *= fade;
    pcm[i] *= fade;
    pcm[pcm_length - i] *= fade;
  }
}
function rotatePhase(spec, theta) {
  var data = spec.data,
      fft_size = spec.fft_size;

  var i = void 0,
      j = void 0,
      col = void 0,
      len = data.length;
  for (i = 0; i < len; i++) {
    col = data[i];
    for (j = 0; j < fft_size; j++) {
      col[j * 2 + 1] += theta;
    }
  }
  return spec;
}

function linearBins(spec, n) {
  n = n || 1;

  var bins = [],
      i = void 0,
      q_i = void 0;
  for (q_i = 0; q_i < n; q_i++) {
    bins[q_i] = [];
  }
  var step = Math.floor(spec.fft_size / n);
  var len_quantize_n = (0, _util.quantize)(spec.fft_size, n);
  for (i = 0; i < len_quantize_n; i++) {
    q_i = Math.floor(i / step);
    bins[q_i] = bins[q_i] || [];
    bins[q_i].push(i);
  }
  // leftover bins get put at end
  for (; i < spec.fft_size; i++) {
    bins[q_i].push(i);
  }
  return bins;
}
function logarithmicBins(spec) {
  var bins = [],
      i = void 0,
      j = void 0,
      q_i = void 0;
  var binCount = Math.log2(spec.fft_size) - 1;
  for (i = 0, q_i = 0, j = 0; i < binCount; i++) {
    j += 1 << i;
    bins[i] = [];
    for (; q_i < j; q_i++) {
      bins[i].push(q_i);
    }
  }
  return bins;
}
function concatBins(bins) {
  return bins.reduce(function (acc, cv) {
    return acc.concat(cv);
  }, []);
}
function reverseBins(bins) {
  return bins.map(function (bin) {
    return bin.reverse();
  });
}
function minBins(bins) {
  return bins.map(function (bin) {
    var b = bin[0];
    return bin.map(function () {
      return b;
    });
  });
}
function maxBins(bins) {
  return bins.map(function (bin) {
    var b = bin[bin.length - 1];
    return bin.map(function () {
      return b;
    });
  });
}
function rotateSpectrum(spec, n) {
  var fft_size = spec.fft_size;

  if (n && n < 1) {
    n -= 0.5;
    n *= fft_size;
  }
  n = Math.floor(n);
  var order = new Array(fft_size),
      i = void 0;
  for (i = 0; i < fft_size; i++) {
    order[i] = (0, _util.mod)(i + n, fft_size / 2);
  }
  return reorderBins(spec, order);
}
function cloneSpectrum(spec) {
  var data = spec.data,
      fft_size = spec.fft_size,
      sr = spec.sr,
      fft_overlap = spec.fft_overlap;

  var spec_len = data.length;

  var new_data = new Array(spec_len);
  var i = void 0;
  for (i = 0; i < spec_len; i++) {
    new_data[i] = data[i].concat();
    new_data[i][2] = 0;
  }

  return {
    data: new_data,
    fft_size: fft_size,
    sr: sr, fft_overlap: fft_overlap
  };
}
function reverseSpectrum(spec) {
  var new_spec = cloneSpectrum(spec);
  new_spec.data = new_spec.data.reverse();
  return new_spec;
}
function shuffleSpectrum(spec) {
  var fft_size = spec.fft_size;

  var order = new Array(fft_size),
      i = void 0;
  for (i = 0; i < fft_size; i++) {
    order[i] = i;
  }
  (0, _util.shuffle)(order);
  return reorderBins(spec, order);
}
function invertSpectrum(spec) {
  var fft_size = spec.fft_size;

  var order = new Array(fft_size),
      i = void 0;
  for (i = 0; i < fft_size; i++) {
    order[i] = fft_size - i - 1;
  }
  return reorderBins(spec, order);
}
function reorderBins(spec, order) {
  var new_spec = cloneSpectrum(spec);
  var data = spec.data,
      sr = spec.sr,
      fft_size = spec.fft_size,
      fft_overlap = spec.fft_overlap;

  var spec_len = data.length;
  var new_data = new_spec.data;


  var i = void 0,
      j = void 0,
      col = void 0,
      new_col = void 0;
  for (j = order.length; j < fft_size; j++) {
    order[j] = j;
  }

  for (i = 0; i < spec_len; i++) {
    col = data[i];
    new_col = new_data[i] = data[i].concat();
    col[0] = 0;
    col[2] = 0;
    col[4] = 0;
    for (j = 0; j < fft_size / 2; j++) {
      new_col[j * 2] = col[order[j] * 2];
      new_col[j * 2 + 1] = col[order[j] * 2 + 1];
    }
    for (; j < fft_size; j++) {
      new_col[j * 2] = 0;
      new_col[j * 2 + 1] = 0;
    }
  }

  return {
    data: new_data,
    sr: sr, fft_size: fft_size, fft_overlap: fft_overlap
  };
}

exports.default = {
  toSpectrum: toSpectrum, fromSpectrum: fromSpectrum, fromImageData: fromImageData, binToHz: binToHz,
  fadeInOut: fadeInOut,
  cloneSpectrum: cloneSpectrum,
  reverseSpectrum: reverseSpectrum, shuffleSpectrum: shuffleSpectrum, invertSpectrum: invertSpectrum, rotateSpectrum: rotateSpectrum,
  reorderBins: reorderBins,
  linearBins: linearBins, logarithmicBins: logarithmicBins,
  concatBins: concatBins,
  reverseBins: reverseBins, minBins: minBins, maxBins: maxBins,
  rotatePhase: rotatePhase
};


//////////////////
// WEBPACK FOOTER
// ./client/lib/spectrum.js
// module id = 58
// module chunks = 0